import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { SliceUserSegmentsRenderComponent } from './render/slice-user-segments-render.component';


export const sliceUserSegmentsRenderModuleEntryComponents = [
  SliceUserSegmentsRenderComponent
];

@NgModule({
  imports: [
    RenderBlocksModule,
    RenderSharedModule,
    SharedModule
  ],
  exports: [
    sliceUserSegmentsRenderModuleEntryComponents
  ],
  declarations: sliceUserSegmentsRenderModuleEntryComponents
})
export class SliceUserSegmentsRenderModule {}

export default sliceUserSegmentsRenderModuleEntryComponents;
